import { memo } from 'react';
import { HoveredButton } from '@ui';
import icons from '@icons';
import './index.scss';
import ShareSocialLinksNew from '@components/ShareSocialLinksNew';
const {
  bookmark: { white: bookmarkWhiteOutlined }
} = icons.Outline;
const {
  bookmark: { red: bookmarkRedFilled }
} = icons.Fill;

const RecipeActions = ({ isFavorite, favoriteHandler, link }) => {
  const onClick = e => {
    e.preventDefault();
    e.stopPropagation();
    favoriteHandler();
  };

  const getLinkWithOrigin = link => {
    if (!link) {
      return '';
    }

    const origin = location.origin;

    let newLink = link
      ?.replace(origin)
      ?.replace('recipes/', '')
      ?.replace('/recipes/', '');

    if (newLink?.[0] === '/') {
      newLink = newLink.replace('/', '');
    }

    return `${origin}/recipes/${newLink}`;
  };

  return (
    <div className='RecipeCard-actions'>
      <HoveredButton
        icon={isFavorite ? bookmarkRedFilled : bookmarkWhiteOutlined}
        iconHover={bookmarkRedFilled}
        onClick={onClick}
        wrapperClassName={'RecipeCard-actions__action'}
        iconHeight={20}
        iconWidth={20}
      />
      <div className='RecipeCard-actions__action'>
        <ShareSocialLinksNew
          offsetYDesktop={0}
          iconWhite
          position={'bottom center'}
          link={getLinkWithOrigin(link)}
        />
      </div>
    </div>
  );
};

export default memo(RecipeActions);
